export const DEFAULT_TEXT = 'Change you made may not be saved'
export const QUIZ_TEXT = 'If you exit the quiz page now, your quiz will be graded only on the questions you have completed. Any questions left blank will be marked incorrect.'
